var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taobao-auth"},[_c('div',{staticClass:"title"},[_vm._v(" 淘客授权 ")]),_c('auth-desc'),_c('auth-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }